"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.useOracleTheme = exports.OracleThemeProvider = void 0;
var react_1 = __importStar(require("react"));
var OracleThemeContext = (0, react_1.createContext)(undefined);
var STORAGE_KEY = 'oracle-theme';
var getSystemTheme = function () {
    // If we want to support user-specified themes, you'll need this code:
    // if (typeof window !== 'undefined' && window.matchMedia) {
    //   return window.matchMedia('(prefers-color-scheme: dark)').matches ? 'dark' : 'light'
    // }
    // return 'light'
    // Dark mode is disabled for now, so we default to light mode no matter what.
    return 'light';
};
var getStoredTheme = function () {
    if (typeof window !== 'undefined') {
        var stored = localStorage.getItem(STORAGE_KEY);
        if (stored === 'light' || stored === 'dark') {
            return stored;
        }
    }
    return getSystemTheme();
};
/**
 * OracleThemeProvider provides a chat-ui-specific theme context and
 * creates a themed container div that applies the theme to its children.
 */
var OracleThemeProvider = function (_a) {
    var children = _a.children, forcedTheme = _a.forcedTheme, containerClass = _a.containerClass;
    var _b = (0, react_1.useState)(function () { return forcedTheme !== null && forcedTheme !== void 0 ? forcedTheme : getStoredTheme(); }), theme = _b[0], setThemeState = _b[1];
    var containerRef = (0, react_1.useRef)(null);
    // When forcedTheme changes, update internal state
    (0, react_1.useEffect)(function () {
        if (forcedTheme) {
            setThemeState(forcedTheme);
        }
    }, [forcedTheme]);
    (0, react_1.useEffect)(function () {
        var applyTheme = function (newTheme) {
            if (containerRef.current) {
                if (newTheme === 'dark') {
                    containerRef.current.setAttribute('data-oracle-theme', 'dark');
                }
                else {
                    containerRef.current.removeAttribute('data-oracle-theme');
                }
            }
        };
        applyTheme(theme);
        // Only persist to localStorage if not using forced theme
        if (!forcedTheme) {
            localStorage.setItem(STORAGE_KEY, theme);
        }
    }, [theme, forcedTheme]);
    var setTheme = function (newTheme) {
        // No-op if forcedTheme is set
        if (!forcedTheme) {
            setThemeState(newTheme);
        }
    };
    var toggleTheme = function () {
        // No-op if forcedTheme is set
        if (!forcedTheme) {
            setTheme(theme === 'light' ? 'dark' : 'light');
        }
    };
    var className = containerClass
        ? "oracle-theme-container ".concat(containerClass)
        : 'oracle-theme-container';
    return (react_1.default.createElement("div", { ref: containerRef, className: className },
        react_1.default.createElement(OracleThemeContext.Provider, { value: {
                theme: theme,
                toggleTheme: toggleTheme,
                setTheme: setTheme,
                containerRef: containerRef,
            } }, children)));
};
exports.OracleThemeProvider = OracleThemeProvider;
var useOracleTheme = function () {
    var context = (0, react_1.useContext)(OracleThemeContext);
    if (context === undefined) {
        throw new Error('useOracleTheme must be used within an OracleThemeProvider');
    }
    return context;
};
exports.useOracleTheme = useOracleTheme;
